<template>
   <div> 
     <div style="width: 150px; height: 150px; margin: 20px auto auto;">
       <img  src="../../assets/img/logohpca3.png" width="90px"/>
     </div>
        <!-- <radial-menu
                style="margin: auto; margin-top: 120px; background-color: #E5F8FB;"
                :itemSize="50"
                :radius="120"
                :angle-restriction="180" >
                
                <radial-menu-item 
                    v-for="(item, index) in itemswithicon" 
                    :key="index" 
                    style="background-color: #E5F8FB" 
                    @click="() => handleClick(item.Name)">
                    <span  v-bind:title="item.Name"><font-awesome-icon v-bind:icon="item.icon" /></span>
                </radial-menu-item>
        </radial-menu> -->
        
   </div>
</template>

<script>
import { RadialMenu,  RadialMenuItem } from 'vue-radial-menu'

  export default {
    name: 'Radialmenucontainer',
    components: {
    RadialMenu,
    RadialMenuItem
    },
    data () {
      return {
        msg: 'Radialmenucontainer',
        itemswithicon:[{
        "Name":"About",
        "icon":"home",
      },
      {
        "Name":"Objectives",
        "icon":"bullseye",
      },
      {
        "Name":"Events",
        "icon":"calendar-check",
      },
      {
        "Name":"Sponsor",
        "icon":"hands-helping",
      },
      {
        "Name":"Gallery",
        "icon":"images",
      },
      {
        "Name":"Contact",
        "icon":"mobile-alt",
      }],
      lastClicked: 'click on something!'
    }
  },
  methods:{
     handleClick (item) {
      this.lastClicked = item;
      this.$emit("HomeDivVisibility", true);
      
      if(item ==='Gallery')
        this.$router.push({name:item,params: { item: 'PhotoGallery' }});
      else
        this.$router.push({name:item});
    }
  }
}

</script>

<style> 

</style>


// WEBPACK FOOTER //
// src/components/sections/Radialmenucontainer.vue